import { render } from "./ModalKpiChat.vue?vue&type=template&id=6754525b&scoped=true"
import script from "./ModalKpiChat.vue?vue&type=script&lang=js"
export * from "./ModalKpiChat.vue?vue&type=script&lang=js"

import "./ModalKpiChat.vue?vue&type=style&index=0&id=6754525b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6754525b"]])

export default __exports__